module.exports = __webpack_public_path__ + "static/media/leaf.a5fc1121.svg";